<template>
    <div class="rounded-lg bg-white overflow-hidden border-1 border-border border-solid my-base p-base shadow-card flex space-between transition-all duration-150 hover:shadow-cardHover hover:bg-cardBackgroundHover">
      <div class="flex-grow w-paymentMethodInfo">
        <div id="invoice-top-row" class="mb-xs">
          <VLabel :type="invoiceStatusLabelType(invoice.status)" class="status-label mr-base" id="invoice-label">
            <template v-slot:text>
              {{ $t(`companySettings.billing.invoices.status.${invoice.status}`) }}
            </template>
          </VLabel>
          <span class="align-middle">
            <b id="invoice-human-id">{{ invoice.human_id }}</b>
            <span id="invoice-created-date"> - {{ invoice.created | formatDate('long') }}</span>
          </span>
        </div>
        <div id="invoice-bottom-row">
          <p class="text-gray-400" id="invoice-total">{{ $t('companySettings.billing.invoices.total') }} {{ $n(parseFloat(invoice.total / 100), 'currency', invoice.currency) }}</p>
        </div>
      </div>
      <div class="inline-flex flex-wrap justify-end content-start items-start gap-sm">
        <VButton
            v-if="invoice.latest_charge_receipt_url"
            id="invoice-receipt-button"
            type="outline-1"
            data-ec="billing_invoice_card"
            data-et="receipt_button"
            :href="invoice.latest_charge_receipt_url"
            target="_blank"
            size="small">
          <span>{{ $t('functional.receipt') }}</span>
        </VButton>
        <VButton
            id="invoice-download-button"
            type="outline-1"
            data-ec="billing_invoice_card"
            data-et="download_button"
            :href="invoice.pdf"
            target="_blank"
            size="small">
          <span>{{ $t('functional.download') }}</span>
        </VButton>
      </div>
    </div>
</template>

<script>
import VButton from '@/components/deprecated/atoms/Button.vue';
import VLabel from '@/components/deprecated/atoms/Label.vue';

export default {
  name: 'BillingInvoice',
  components: {
    VLabel,
    VButton,
  },
  props: {
    invoice: {
      type: [Object],
      required: true,
    },
  },
  methods: {
    invoiceStatusLabelType(status) {
      switch (status) {
        case 'paid':
          return 'success';
        case 'unpaid':
          return 'warning';
        case 'void':
          return 'purple';
        case 'uncollectible':
          return 'error';
        case 'open':
        case 'draft':
        default:
          return 'info';
      }
    },
  },
};
</script>

<style scoped>
/* Remove once label refactored */
.status-label {
  margin-bottom: 0;
  margin-right: var(--spacing-small);
  float: none;
  display: inline-block;
  vertical-align: middle;
}

</style>
